import ViewContext from './ViewContext';
import Ribbon from '../component/ribbon/Ribbon';
import WidgetStateContext from '../context/WidgetState';

export function View(widget) {
	const { unfixed, showMenu, searchQuery, links } = widget.state;

	return (
		<ViewContext.Provider value={widget}>
			<WidgetStateContext.Provider value={widget.state}>
				<Ribbon
					unfixed={unfixed}
					showMenu={showMenu}
					searchQuery={searchQuery}
					links={links}
				/>
			</WidgetStateContext.Provider>
		</ViewContext.Provider>
	);
}
